import React,{useState,useEffect} from 'react';
import { useSelector} from "react-redux";
import {Button,Drawer,Input,Space,Form,Select,InputNumber } from 'antd';
import { DownloadOutlined,PlusCircleFilled,EditFilled ,DeleteFilled} from '@ant-design/icons';

import debounce from 'lodash/debounce';
import useAxios from './../../../CustomHooks/useAxios';
import DebounceSelect from './../../DebounceSelect'
const {TextArea} = Input;
const { Option } = Select;
export default function Edit({item,setRefressSearch,setVisibleEdit,setSelectedItem}) {
  
  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const user = useSelector((state) => state.loginReducer.user);
  const {axiosi}=useAxios();
  const [form] = Form.useForm();
  const [telsoutData,setTelsoutData]=useState(null);
  const [telout,setTelout]=useState(item.telout);
  const [companyid, setCompanyid] = React.useState({value:item.company_id,label:item.company_name});

  const [mainDialPlanData,setMainDialPlanData]=useState(null);
  const [mainDialPlainSelectedid,setMainDialPlainSelectedid]=useState(item.maindialplanid);

    useEffect(()=>{
      const getteloutdata=async(value)=>{
        const kq= await axiosi.get('tels',{params:{companyid:value,pageSize:100}});
          console.log("[handleOnChangeCompanyName]:kq_get_tels=",kq);
          console.log("[handleOnChangeCompanyName]:selectedvalue=",value);
          setTelsoutData(kq.data);
          setTelout(item.telout);
          
      }
        if(item?.company_id){
          getteloutdata(item?.company_id);
        } 
          
    },[item?.company_id])
    const onFinishAdd=async (values)=>{
        let adddata={...values,company_id:companyid.value,telout,maindialplanid :mainDialPlainSelectedid   };
       
        try {
            const kq=await axiosi.put(`surveyplan/${item.id}`,adddata);
            console.log("[onFinishAdd]:kq=",kq) ;
            // form.resetFields();
            setSelectedItem(null);
            setVisibleEdit(false);
            setRefressSearch(pre=>!pre);
        } catch (error){
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log("error.response.data:",error.response.data);
                console.log("error.response.status:",error.response.status);
                console.log("error.response.headers:",error.response.headers);
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log("error.request :",error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error error.message', error.message);
              }
              console.log("error.config:",error.config);
        }
    }
    const onFinishFailedAdd=(error)=>{
        console.log("[onFinishFailedAdd]:error=",error);
    }

    const handleOnChangeTelsout=async(value)=>{
      setTelout(value);
      console.log("[handleOnChangeTelsout]:value=",value);
      console.log("[handleOnChangeTelsout]:telsoutData=",telsoutData);
    }
    const handleOnChangeCompanyName=async(value)=>{
          setCompanyid(value);
          // const kq= await axiosi.get('tels',{params:{companyid:value.value,pageSize:100}});
          // console.log("[handleOnChangeCompanyName]:kq_get_tels=",kq);
          // console.log("[handleOnChangeCompanyName]:selectedvalue=",value);

          if(value){
            const kq= await axiosi.get('tels',{params:{companyid:value.value,pageSize:100}});
            console.log("[handleOnChangeCompanyName]:kq_get_tels=",kq);
            console.log("[handleOnChangeCompanyName]:selectedvalue=",value);
            setTelsoutData(kq.data);
            setTelout("");
            } else {
              setTelsoutData(null);
              setTelout("");
            }
          
            if (value){
              const kq=await axiosi.get('ivrplanmain',{params:{company_id:value.value,pageSize:100}});
              console.log("[useEffect-getMainDialplan]:kq=",kq)
              setMainDialPlanData(kq.data.rows);
              setMainDialPlainSelectedid('');
                } 
            else {
                  setMainDialPlanData(null);
                  setMainDialPlainSelectedid('');
                }
              
          
    }

    async function fetchUserList(company_name) {        
      console.log('fetching user', company_name);
      const body=await axiosi.get('companies',{params:{company_name,pageSize:100}} );
      if (body?.data?.rows) {
          return body?.data?.rows.map((user) => ({
              label: user.company_name,
               value: user.id,
              //  value:{id: user.id,company_code:user.company_code},
               company_code:user.company_code,
             }));
      }
      else {
          const a=[{label:"---no data---",value:""}]
          return a.map(i=> (i))
      }
     
  }
    

  const handleOnChangeMainDialPlan=(value)=>{
    setMainDialPlainSelectedid(value);
    console.log("[handleOnChangeMainDialPlan]:value=",value)
  }
  
  function onSearch(val) {
    console.log('search:', val);
  }
  useEffect(()=>{
    const getMainDialplan=async(companyid)=>{
      try {
        if (companyid){
      const kq=await axiosi.get('ivrplanmain',{params:{company_id:companyid.value,pageSize:100}});
      console.log("[useEffect-getMainDialplan]:kq=",kq)
      setMainDialPlanData(kq.data.rows);
        } else {
          setMainDialPlanData(null);
        }
      }
      catch (err){
        console.log("[useEffect-getMainDialplan]:err=",err);
      }

    }
    getMainDialplan(item?.company_id);
  },[item?.company_id])

  return (<>
  
        <Form form={form}
      name="basic"
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 15 }}
      initialValues={item}
      onFinish={onFinishAdd}
      onFinishFailed={onFinishFailedAdd}
      autoComplete="off"
    >
      

        <Form.Item className={hideItem}
        label="Company Name"
        // name="company_name"
        rules={[{ required: (hideItem!=="hideItem"), message: 'Please input a company_name!' }]}
      >
        <DebounceSelect
          showSearch={true}
          value={companyid}
          placeholder="Select users"
          fetchOptions={fetchUserList}
          onChange={handleOnChangeCompanyName}          
          style={{  width: '100%', }}
        />
      </Form.Item>
      <Form.Item
        label="Name :"
        name="name"
        rules={[{ required: true, message: 'Please input a survey name!' }]}
      >
        <Input  />  
        </Form.Item>
        <Form.Item
        label="Tel out :"
        // name="pbxtel"
        rules={[{ required: false, message: 'Please input a Tel out numbe!' }]}
      >
        {telsoutData?.rows && <>
            <Select style={{ width: '100%' }} 
                    onChange={handleOnChangeTelsout}
                    //(value)=>setMenu_item_id(value)}
                    // loading={menuItemDataLoading}
                    value={telout}                   
            >
                        <Option value=""></Option>
                        { telsoutData?.rows && telsoutData.rows.map(item=>(
                           <Option key={item.telin} value={item.telin}>{item.telin}</Option>
                       ))}                       
            </Select>
        
      </>}
      </Form.Item>

      <Form.Item
      
        label="maindialplanid :"
        // name="maindialplanid"
        rules={[{ required: true, message: 'Please input a maindialplanid!' }]}
      >
        {mainDialPlanData && <>
            <Select style={{ width: '100%' }}  showSearch
                    onChange={handleOnChangeMainDialPlan}
                    //(value)=>setMenu_item_id(value)}
                    // loading={menuItemDataLoading}
                    value={mainDialPlainSelectedid}
                    optionFilterProp="children"
                    placeholder="Select a person"
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    
            >
                        <Option value=""></Option>
                        { mainDialPlanData && mainDialPlanData.map(item=>(
                           <Option key={item.id} value={item.id}>{item.name}</Option>
                       ))}                       
            </Select>
        
      </>}     
      
      </Form.Item>

      <Form.Item
        label="numcurrentcall :"
        name="numcurrentcall"
        rules={[{ required: true, message: 'Please input a numcurrentcall!' }]}
      >
        <InputNumber min={1}   />  
        </Form.Item>
        <Form.Item
        label="allownumcall :"
        name="allownumcall"
        rules={[{ required: true, message: 'Please input a allownumcall!' }]}
      >
        <InputNumber min={1}   />  
        </Form.Item>
        <Form.Item
        label="minutebetweencall :"
        name="minutebetweencall"
        rules={[{ required: true, message: 'Please input a minutebetweencall!' }]}
      >
        <InputNumber min={1}   />  
        </Form.Item>
        <Form.Item
        label="allowdaycall :"
        name="allowdaycall"
        rules={[{ required: true, message: 'Please input a allowdaycall!' }]}
      >
        <InputNumber min={1}   />  
        </Form.Item>
        

      <Form.Item
        label="manualsurvey :"
        name="manualsurvey"
        rules={[{ required: true, message: 'Please input a manualsurvey!' }]}
      >
        <Select style={{ width: '100%' }}>
            <Option value={0}>No</Option>
            <Option value={1}>Yes</Option>
          </Select>       
      </Form.Item>
      


      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
        </Form>
  </>);
}
